import dayjs from "dayjs";
import { useState } from "react";
import { Link } from "react-router-dom";
import { IMAGE_BASE_URL } from "../../common/Constants";
import { toast } from "react-toastify";
import Noimage from "../../images/noimage.png";

const BankCard = (props) => {
  const InterestIndex = props.interestSort;
  const product = props.product;
  const Interest = product.interests[InterestIndex
  ];
  const selectedYear = 1;

  const [isExpanded, setIsExpanded] = useState(false);


  let startDate = Interest?.startDate ? dayjs(Interest?.startDate).format("DD MMM YYYY").toUpperCase() : null;
  let endDate = Interest?.endDate ? dayjs(Interest?.endDate).format("DD MMM YYYY").toUpperCase() : null;
  const handleAgentBonus = (e) => {
    e.preventDefault();
    const agentData = {
      name: product.name,
      icon: product.icon,
      startDate,
      endDate,
      interest: Interest?.interest
    }
    if (product?.bonuses && product?.bonuses.length > 0) {
      props.allAgentBonus(agentData, product?.bonuses);
    } else {
      toast.warning("Bonus is not available for the product..!")
    }
  }

  return (
    <Link to={`/loan-products/${product.id}/${selectedYear}`} state={{ ...props?.pagePermission }}
      className={`min-h-[310px] no-underline text-black hover:text-black focus:text-black rounded-[16px] bg-white  p-[0px_20px] w-[32%] max-[1300px]:w-[48%] max-[1200px]:w-[48%] max-[700px]:w-[100%] max-w-[100%] cus_shadow2 relative ${isExpanded ? "z-[9]" : "z-0"
        }`}>
      <div className="back-card-expand rounded-[16px] shadow-[0_4px_30px_rgba(0,0,0,0.1)] border border-[#e0e0e0]">
        <div className="absolute top-[-19px] right-[30px] p-[2px_8px] text-white text-[10px] rounded-[4px_4px_0_0] z-[-1]" style={{ backgroundColor: product?.cardheadercolor }}>{product?.cardheadertext}</div>
        <div className="card_head relative flex justify-between items-center">
          <div className="absolute top-[-33px] left-0 bg-white h-[58px] w-[58px] rounded-[8px]">
            {/* <img src={`${IMAGE_BASE_URL}${product.icon}`} alt="Bank Logo" className="rounded-[8px]" width="58" height="58" style={{ maxWidth: '100%', height: 'auto' }} /> */}
            <img
              src={
                product?.icon
                  ? `${IMAGE_BASE_URL}/${product.icon}`
                  : Noimage // ✅ Use fallback image if no avatar
              }
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = Noimage; // ✅ Set fallback image on error
              }}
              alt="Bank Logo"
              className="rounded-[8px]"
              width="58"
              height="58"
              style={{ width: "auto", height: "40px", margin: "10px auto" }}
            />
          </div>
          <span className="pl-[70px] font-[700] text-[15px] font-semibold text-gray-800 truncate mt-[0px]">
            {product.name}
          </span>
          <div>
            <div className="text-[23px] font-[700]">{Interest?.interest}%</div>
            {/* <div className="text-[13px] text-[#0F59F9]" onClick={handleAgentBonus}>Bonus ({product?.totalBonuses})</div>   */}
          </div>
        </div>

        <div className="flex items-center gap-x-2 h-[36px]">
          {
            product.hasPremium || product.featured ?
              <span className="inline-block">
                {
                  product.hasPremium ?
                    <span className="inline-flex text-[13px] items-center border border-[#E1E1E1] gap-[0_6px] rounded-[4px] p-[4px_10px] text-[#263238] font-[500] mr-[10px]"><img src="/images/prem_icon.svg" className="w-[16px]" alt="star" /> <span className="relative top-[1px]">Premium</span></span>
                    : null
                }
                {
                  product.featured ?
                    <span className="inline-flex text-[13px] items-center border border-[#E1E1E1] gap-[0_6px] rounded-[4px] p-[4px_10px] text-[#263238] font-[500]"><img src="/images/star.svg" className="w-[16px]" alt="star" /> <span className="relative top-[1px]">Featured</span></span>
                    : null
                }
              </span> : null
          }
        </div>


        <div className="flex flex-wrap gap-[5px] mt-[5px] mb-[5px] min-h-[82px]">
          {/* <div className="text-[11px] text-[#787486]">
          <p className="mb-[0]">{Interest?.remarks1.substring(0, 50)}{Interest?.remarks1.length > 50 && '...'}</p>
          <p className="mt-[2px] mb-[0]">{Interest?.remarks2.substring(0, 50)}{Interest?.remarks2.length > 50 && '...'}</p>
        </div> */}

          {/* {Array.isArray(Interest?.remarks) && Interest.remarks.length > 0 && (
          <div className="text-[11px] text-[#787486]">
            {Interest.remarks.map((item, idx) => (
              <p
                key={idx}
                className={`${idx !== 0 ? 'mt-[2px]' : ''} mb-[0]`}
              >
                {item.text.length > 50
                  ? `${item.text.substring(0, 50)}...`
                  : item.text}
              </p>
            ))}
          </div>
        )} */}


          <div className="w-full text-[13px] text-[#333]">
            {Array.isArray(Interest?.remarks) && (
              <>
                <ul className="list-disc pl-4 space-y-[4px] m-0 transition-all duration-300 ease-in-out">
                  {(isExpanded ? Interest.remarks : Interest.remarks.slice(0, 3)).map((item, idx) => (
                    <li key={idx} className="text-[12px] text-black leading-[1.4]">
                      <span className={`block ${!isExpanded ? "truncate overflow-hidden whitespace-nowrap text-ellipsis" : ""}`}
                        title={item?.text || ""} >
                        {item?.text || ""}
                      </span>
                    </li>
                  ))}
                </ul>

                {Interest.remarks.length > 3 && (
                  <div className="text-center">
                    <span
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setIsExpanded((prev) => !prev);
                      }}
                      className="text-blue-600 mt-1 inline-block cursor-pointer text-[13px] font-bold"
                    >
                      {isExpanded ? "Read less" : "See more"}
                    </span>

                  </div>
                )}
              </>
            )}
          </div>

        </div>
        <p className="text-[12px] mb-[8px] flex items-center">
          <img src="/images/fi_dollar.svg" alt="calendar" className="mr-[5px]" />
          Min. Loan: <strong className="ml-[5px] font-[600]">{Interest?.minimum_loan_amount > 0 ? '$' + parseInt(Interest?.minimum_loan_amount) : 'No min. loan required'} {Interest?.admin_fee_status === "1" && `else + admin fee $${parseInt(Interest?.admin_fee)}`}</strong>
        </p>
        <p className="text-[12px] mb-[8px] flex items-center">
          <img src="/images/fi_calendar.svg" alt="calendar" className="mr-[5px]" />
          Available from: <strong className="ml-[5px] font-[600]">
            {startDate}
            <span className="mx-[6px]">to</span>
            {endDate ? endDate : 'Further Notice'}
          </strong>
        </p>
        <div className="flex flex-wrap items-center justify-between gap-[5px_10px]">

          <p className="text-[12px] mb-[0] flex items-center">
            <img src="/images/fi_clock.svg" alt="calendar" className="mr-[5px]" />
            Approval time: <strong className="ml-[5px] font-[600]">{product?.approvaltimeinfo?.name}</strong>
          </p>
          <p className="text-[12px] mb-[0] flex items-center">
            <img src="/images/fi_zap.svg" alt="calendar" className="mr-[5px]" />
            Loan to Value: <strong className="ml-[5px] font-[600]">{product?.ltvinfo?.name}</strong>
          </p>
        </div>
      </div>
    </Link>
  )
};

export default BankCard;
